<template>
  <!-- Поле поиска: скруглённое, без рамки, лупа слева, «очистить» справа; в
       режиме поиска рядом - текстовая кнопка «Отмена» (как в 2ГИС). -->
  <!-- pointerdown.prevent на кнопках: фокус остаётся в поле до click (Safari
       иначе снимает фокус, и видимая только при фокусе «Отмена» исчезает до нажатия). -->
  <div class="flex items-center gap-3">
    <div class="relative flex-1 min-w-0 rounded-xl bg-muted/70 border border-transparent focus-within:border-ring/50 focus-within:bg-card transition-colors">
      <Search class="absolute left-3 top-1/2 -translate-y-1/2 w-[18px] h-[18px] text-muted-foreground pointer-events-none" aria-hidden="true" />
      <input
        ref="inputEl"
        :value="modelValue"
        type="search"
        :placeholder="placeholder"
        class="search-own-clear w-full h-11 pl-10 pr-10 bg-transparent rounded-xl text-[15px] outline-none"
        @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
        @focus="$emit('focus')"
        @keydown="$emit('keydown', $event)"
        @keydown.esc="$emit('cancel')"
        @pointerdown.stop
      />
      <button
        v-if="modelValue"
        type="button"
        class="absolute right-2 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center rounded-full text-muted-foreground hover:bg-accent"
        data-search-clear
        :aria-label="$t('common.dismissLabel')"
        @pointerdown.stop.prevent
        @click="$emit('update:modelValue', ''); inputEl?.focus()"
      >
        <X class="w-4 h-4" aria-hidden="true" />
      </button>
    </div>
    <button
      v-if="active"
      type="button"
      data-search-cancel
      class="shrink-0 text-[15px] font-medium text-primary"
      @pointerdown.stop.prevent
      @click="$emit('cancel')"
    >{{ $t('search.cancel') }}</button>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { Search, X } from "lucide-vue-next";
import { useTypingPlaceholder } from "../../composables/useTypingPlaceholder";

const props = defineProps<{ modelValue: string; active: boolean }>();
const { t } = useI18n();
// Подсказка «печатает» примеры запросов, пока поле не в фокусе и пусто.
const placeholder = useTypingPlaceholder({
  base: computed(() => t("leftPanel.searchPlaceholder")),
  examples: computed(() => [1, 2, 3, 4].map((n) => t(`search.example${n}`))),
  paused: computed(() => props.active || props.modelValue !== ""),
});
defineEmits<{
  (e: "update:modelValue", v: string): void;
  (e: "focus"): void;
  (e: "cancel"): void;
  (e: "keydown", ev: KeyboardEvent): void;
}>();

const inputEl = ref<HTMLInputElement | null>(null);
defineExpose({ blur: () => inputEl.value?.blur(), focus: () => inputEl.value?.focus() });
</script>
